import { BRANCH, HOST } from './env'

export const BASE_URL = HOST

export const PATH = {
  home: '/',
  events: '/events/',
  demoUrl: '/demo/',
  pricingUrl: '/pricing/',
  accountTakeover: '/use-cases/account-takeover/',
  ecommerce: '/e-commerce/',
  gaming: '/igaming/',
  travel: '/travel/',
  cryptocurrency: '/cryptocurrency/',
  paymentFraud: '/use-cases/payment-fraud/',
  blog: '/blog/',
  paywall: '/use-cases/paywall/',
  caseStudies: '/case-studies/',
  contactSales: '/contact-sales/',
  whyFpjs: '/products/fingerprint-pro/',
  identification: '/products/identification/',
  accountSharing: '/use-cases/account-sharing-prevention/',
  botD: '/products/bot-detection/',
  bnpl: '/buy-now-pay-later/',
  careers: '/careers/',
  aiinfopage: '/blog/ai-info-page/',
  support: '/support/',
  security: '/security/',
  useCases: '/use-cases/',
  tutorials: '/blog/tag/tutorials/',
  guides: '/blog/tag/guides/',
  resources: '/resources/',
  templates: '/templates/',
  faq: '/resources/frequently-asked-questions-faqs/',
  press: '/resources/press/',
  vsThreatMetrix: '/resources/comparisons/compare-fingerprint-vs-threatmetrix/',
  vsTruValidate: '/resources/comparisons/compare-fingerprint-vs-truvalidate/',
  integrations: '/integrations/',
  sdks: '/sdk-libraries/',
  github: '/github/',
  aboutUs: '/about-us',
  smartSignals: '/products/smart-signals/',
  partners: '/partners/',
  finserv: '/fintech',
  banking: '/banking',
  smsFraud: '/use-cases/sms-fraud/',
  personalization: '/blog/providing-personalization-to-anonymous-users/',
  couponPromo: '/blog/prevent-coupon-promo-abuse-increase-sales/',
  credentialStuffing: '/blog/credential-stuffing-prevention-checklist/',
  newAccountFraudPrevention: '/use-cases/new-account-fraud-prevention/',
  mobileAppDetection: '/use-cases/mobile-app-detection/',
  returningUserExperience: '/use-cases/returning-user-experience/',
  webBotAuthTest: '/web-bot-auth/test/',
  automationDetection: '/products/ai-agent-detection/',
} as const

export const URL = {
  githubRepoUrl: 'https://github.com/fingerprintjs/fingerprintjs/',
  githubApiUrl: 'https://api.github.com/repos/fingerprintjs',
  githubCommunityRepoUrl: 'https://github.com/fingerprintjs/home',
  botDRepoUrl: 'https://github.com/fingerprintjs/BotD',
  botDIntegrationsRepoUrl: 'https://github.com/fingerprintjs/botd-integrations',
  dashboardLoginUrl: 'https://dashboard.fingerprint.com/login',
  careersUrl: 'https://boards.greenhouse.io/fingerprintjs/',
  careersConsoleLogUrl: 'https://fingerprint.com/careers/',
  linkedinUrl: 'https://www.linkedin.com/company/fingerprintjs/',
  twitterUrl: 'https://twitter.com/FingerprintJs/',
  signupUrl: 'https://dashboard.fingerprint.com/signup',
  statusUrl: 'https://status.fingerprint.com',
  supportMail: 'support@fingerprint.com',
  salesMail: 'sales@fingerprint.com',
  worKMail: 'work@fingerprint.com',
  pressMail: 'press@fingerprint.com',
  securityMail: 'security@fingerprint.com',
  discordServerURL: 'https://discord.gg/ad6R2ttHVX',
  docsUrl: 'https://docs.fingerprint.com',
  promotionalVideo: 'https://www.youtube.com/embed/UEYBysyPTBs',
  demoVideo: 'https://www.youtube.com/embed/hVktdWfyBuU',
  g2ReviewUrl: 'https://www.g2.com/products/fingerprintjs-fingerprint/reviews',
  hubUrl: 'https://demo.fingerprint.com/',
  planUrl: 'https://dashboard.fingerprint.com/plan',
  templatesUrl: 'https://dashboard.fingerprint.com/templates/',
} as const

export const DOC_URL = {
  documentationUrl: URL.docsUrl,
  proVsOpenUrl: 'https://fingerprint.com/github',
  browserFingerprintUrl: `${URL.docsUrl}/docs/introduction`,
  incognitoUrl: `${URL.docsUrl}/docs/smart-signals-reference`,
  serverApiUrl: `${URL.docsUrl}/docs/server-api`,
  legalUrl: `${URL.docsUrl}/docs/dpa-gdpr`,
  termOfUseUrl: `${URL.docsUrl}/docs/terms-of-service`,
  privacyPolicyUrl: `${URL.docsUrl}/docs/privacy-policy`,
  browserSupportUrl: `${URL.docsUrl}/docs/browser-and-device-support`,
  webhooksUrl: `${URL.docsUrl}/docs/webhooks`,
  botDUrl: 'https://github.com/fingerprintjs/BotD#botd',
  zeroTrustUrl: `${URL.docsUrl}/docs/zero-trust-mode`,
  migrateUrl: `${URL.docsUrl}/docs/migrating-from-fingerprintjs-to-fingerprint-pro#migrating-from-fingerprintjs-v3-open-source-to-fingerprint-identification`,
  botDetectionGuide: `${URL.docsUrl}/docs/bot-detection/overview`,
  jsAgent: `${URL.docsUrl}/reference/js-agent`,
  quickStartCustomSubdomain: `${URL.docsUrl}/docs/custom-subdomain-setup`,
  quickStartWebhooks: `${URL.docsUrl}/docs/webhooks`,
  quickStartServerApi: `${URL.docsUrl}/docs/server-api`,
  pricing: `${URL.docsUrl}/docs/billing`,
  serverApi: `${URL.docsUrl}/reference/server-api`,
  smartSignalsMobile: `${URL.docsUrl}/docs/smart-signals-reference#smart-signals-for-mobile-devices`,
  gettingStartedMobile: `${URL.docsUrl}/docs/mobile-sdks`,
} as const

export const defaultDataLayer = [{ branch: BRANCH }]

export const notificationBarPages = [
  { name: 'Homepage', pages: [PATH.home] },
  { name: 'Blog', pages: [PATH.blog] },
  { name: 'Products', pages: ['/products/'] },
  { name: 'Case Studies', pages: [PATH.caseStudies] },
  {
    name: 'Solutions and Use Cases',
    pages: [
      PATH.paymentFraud,
      PATH.accountTakeover,
      PATH.accountSharing,
      PATH.paymentFraud,
      PATH.ecommerce,
      PATH.bnpl,
      PATH.gaming,
      PATH.cryptocurrency,
      PATH.useCases,
    ],
  },
  { name: 'About', pages: [PATH.aboutUs] },
  { name: 'Contact (Sales, Support)', pages: [PATH.contactSales, PATH.support] },
  { name: 'Careers', pages: [PATH.careers] },
  { name: 'Press', pages: [PATH.press] },
  { name: 'FAQ', pages: [PATH.faq] },
  { name: 'Integrations and SDKs', pages: [PATH.integrations, PATH.sdks] },
  { name: 'Pricing', pages: [PATH.pricingUrl, '/pricing-a/', '/pricing-b/'] },
  { name: 'Demo', pages: [PATH.demoUrl] },
  { name: 'GitHub', pages: [PATH.github] },
] as const
